class DiagSmoon {
    constructor(el, options = {}){ 

        this.diag = el;
        this.stepCurrent = 0;
        this.diagData = {}; 
        this.diagPunchline = {};
 

        this.countStep = document.querySelectorAll(".content-diag-step").length; 

        this.options = Object.assign(
            {},
            {  
                mode: "guest", 
                dev: false,
                apiK: "PLsVgr"
            }, 
            options
        );    
        document.querySelectorAll(".goto").forEach(goto => {
            goto.addEventListener("click", () => { 
                let index = parseInt(goto.getAttribute("data-goto")); 
                this.goToStep(index);
            });
        });   

        document.querySelector(".share").addEventListener("click", () => { 
            this.partagerPDF(document.querySelector(".share").getAttribute("data-url"));
        });
 
        this.diagQR = {};

        this.diagSettings = {
            "peau" : "",
            "symptome" : "",
            "flux": "",
            "email" : ""
        };

        this.diagProducts = {
            "smoon" : {
                "string-menstruel-aphrodite-flux-leger" : {
                    "img": "https://smoon-lingerie.com/cdn/shop/files/String_Noir_3_600x.jpg",
                    "titre": "Culotte menstruelle <span>Aphrodite</span>",
                    "price": "32,00",
                    "flux" : "léger",
                    "gouttes" : 1,
                    "rating" : 4.7,
                    "url" : "https://smoon-lingerie.com/products/string-menstruel-aphrodite-flux-leger"
                }, 
                "culotte-menstruelle-selene-flux-moyen" : {
                    "img": "https://smoon-lingerie.com/cdn/shop/files/Selene_Bordeaux_1_4aae4256-d9ae-4886-8717-cedee560a514_600x.jpg",
                    "titre": "Culotte menstruelle <span>Séléné</span>",
                    "price": "35,00",
                    "flux" : "moyen",
                    "gouttes" : 2,
                    "rating" : 4.6,
                    "url" : "https://smoon-lingerie.com/products/culotte-menstruelle-selene-flux-moyen"
                },
                "culotte-de-bain-menstruelle-ligie" : {
                    "img": "https://smoon-lingerie.com/cdn/shop/files/Ligie_Bordeaux_1_600x.webp",
                    "titre": "CCulotte de bain menstruelle à nœuds <span>Ligie</span>",
                    "price": "50,00",
                    "flux" : "moyen",
                    "gouttes" : 2,
                    "rating" : 4.5,
                    "url" : "https://smoon-lingerie.com/products/culotte-de-bain-menstruelle-ligie"
                }, 
                "culotte-menstruelle-artemis-flux-abondant" : {
                    "img": "https://smoon-lingerie.com/cdn/shop/files/Artemis_Bleu_4_600x.jpg",
                    "titre": "Culotte menstruelle <span>Artémis</span>",
                    "price": "39,00",
                    "flux" : "abondant",
                    "gouttes" : 3,
                    "rating" : 4.5,
                    "url" : "https://smoon-lingerie.com/products/culotte-menstruelle-artemis-flux-abondant"
                },
                "maillot-de-bain-menstruel-plage-nereides" : {
                    "img": "https://smoon-lingerie.com/cdn/shop/files/Nereides_Noir_1_600x.jpg",
                    "titre": "Maillot de bain menstruel <span>Néréides</span>",
                    "price": "59,99",
                    "flux" : "moyen",
                    "gouttes" : 2,
                    "rating" : 4.5,
                    "url" : "https://smoon-lingerie.com/products/maillot-de-bain-menstruel-plage-nereides"
                },
                "culotte-menstruelle-hecate-flux-ultra-abondant" : {
                    "img": "https://smoon-lingerie.com/cdn/shop/files/Culotte_pour_flux_tres_abondant_3_600x.jpg",
                    "titre": "Culotte menstruelle <span>Hécate</span>",
                    "price": "45,00",
                    "flux" : "très abondant",
                    "gouttes" : 4,
                    "rating" : 4.6,
                    "url" : "https://smoon-lingerie.com/products/culotte-menstruelle-hecate-flux-ultra-abondant"
                },
                "culotte-de-bain-menstruelle-heleades" : {
                    "img": "https://smoon-lingerie.com/cdn/shop/files/Culotte_Adulte_1_1_600x.webp",
                    "titre": "Culotte de bain menstruelle <span>Héléades</span>",
                    "price": "45,00",
                    "flux" : "moyen",
                    "gouttes" : 2,
                    "rating" : 4.4,
                    "url" : "https://smoon-lingerie.com/products/culotte-de-bain-menstruelle-heleades"
                },
                "culotte-menstruelle-detachable" : {
                    "img": "https://smoon-lingerie.com/cdn/shop/files/FP_CULOTTE_DETACHABLE_5_600x.jpg",
                    "titre": "Culotte menstruelle détachable <span>Héméra</span>",
                    "price": "44,00",
                    "flux" : "abondant",
                    "gouttes" : 3,
                    "rating" : 4.5,
                    "url" : "https://smoon-lingerie.com/products/culotte-menstruelle-detachable"
                } 
            },
            "nov" : {
                "serum-booster-acide-hyaluronique": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/booster_serum_hyaluronique-2K_800x.webp?v=1704728444",
                    "titre": "Sérum Booster à l'Acide Hyaluronique",
                    "benefices": "Comble mes rides, Repulpe, Lisse",
                    "rating": "4.8",
                    "price": "39,96",
                    "color": "#be2664",
                    "l1": "H",
                    "l2": "A",
                    "url": "https://novexpert-lab.com/products/serum-booster-acide-hyaluronique",
                    "cat" : "Acide hyaluronique"
                },
                "mousse-nettoyante-flash-eclat": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/mousse_nettoyante_2K_b842a8f1-8596-4adf-9edd-941a6fb281ca_800x.webp?v=1704725215",
                    "titre": "Mousse Nettoyante Flash Éclat",
                    "benefices": "Texture onctueuse, Peau nette, Teint lumineux",
                    "rating": "4.8",
                    "price": "15,96",
                    "color": "#ec7802",
                    "l1": "V",
                    "l2": "C",
                    "url": "https://novexpert-lab.com/products/mousse-nettoyante-flash-eclat",
                    "cat" : "Vitamine C"
                },
                "booster-a-la-vitamine-c": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/booster_vit_c_2K_800x.webp?v=1704789784",
                    "titre": "Sérum Booster à la Vitamine C",
                    "benefices": "Eclat du teint, Anti-âge, Non photosensibilisant",
                    "rating": "4.8",
                    "price": "42,00",
                    "color": "#ec7802",
                    "l1": "V",
                    "l2": "C",
                    "url": "https://novexpert-lab.com/products/booster-a-la-vitamine-c",
                    "cat" : "Vitamine C"
                },
                "la-creme-repulp": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/creme_repulp-2k_fc7b8af9-a530-47e9-b59a-31bc33688edf_800x.webp?v=1704728480",
                    "titre": "La Crème Repulp",
                    "benefices": "Anti-âge, Fermeté, Peau rebondie",
                    "rating": "4.7",
                    "price": "31,96",
                    "color": "#be2664",
                    "l1": "H",
                    "l2": "A",
                    "url": "https://novexpert-lab.com/products/la-creme-repulp",
                    "cat" : "Acide hyaluronique"
                },
                "gelee-moussante-peau-nette": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/gelee_moussante_2k_800x.webp?v=1704725577",
                    "titre": "Gelée Moussante Peau Nette",
                    "benefices": "Nettoie, Purifie, Zéro tiraillement",
                    "rating": "4.8",
                    "price": "14,36",
                    "color": "#51baad",
                    "l1": "Z",
                    "l2": "N",
                    "url": "https://novexpert-lab.com/products/gelee-moussante-peau-nette",
                    "cat" : "Trio-Zinc"
                },
                "fluide-purete": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/fluide_purete_2k_800x.webp?v=1704725542",
                    "titre": "Fluide Pureté",
                    "benefices": "Anti-imperfections, Matifiant, Anti-âge",
                    "rating": "4.7",
                    "price": "21,56",
                    "color": "#51baad",
                    "l1": "Z",
                    "l2": "N",
                    "url": "https://novexpert-lab.com/products/fluide-purete",
                    "cat" : "Trio-Zinc"
                },
                "brume-trio-zinc": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/brume_trio_zinc_2k_800x.webp?v=1704984355",
                    "titre": "Brume Trio-Zinc",
                    "benefices": "Matifie, Apaise, Purifie",
                    "rating": "4.8",
                    "price": "7,96",
                    "color": "#51baad",
                    "l1": "Z",
                    "l2": "N",
                    "url": "https://novexpert-lab.com/products/brume-trio-zinc",
                    "cat" : "Trio-Zinc"
                },
                "huile-demaquillante-aux-5-omegas": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/huile-demaq-v2_LD_800x.webp?v=1718631327",
                    "titre": "Huile Démaquillante aux 5 Omégas",
                    "benefices": "Nettoie, Anti-pollution, 8h de confort",
                    "rating": "4.8",
                    "price": "19,96",
                    "color": "#e5bf56",
                    "l1": "O",
                    "l2": "M",
                    "url": "https://novexpert-lab.com/products/huile-demaquillante-aux-5-omegas",
                    "cat" : "Omégas"
                },
                "stop-bouton-express": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/stop_bouton_2k_800x.webp?v=1704725655",
                    "titre": "Stop Bouton Express",
                    "benefices": "Assainit, Assèche, Résorbe",
                    "rating": "4.7",
                    "price": "13,56",
                    "color": "#51baad",
                    "l1": "Z",
                    "l2": "N",
                    "url": "https://novexpert-lab.com/products/stop-bouton-express",
                    "cat" : "Trio-Zinc"
                },
                "creme-douceur-hydro-biotique": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/creme_doceur_2K_d7bc85ca-9c6b-4cda-9a98-4c6df6278be6_800x.webp?v=1704727944",
                    "titre": "Crème Douceur Hydro-Biotique",
                    "benefices": "Apaise, Préserve, Protège",
                    "rating": "4.8",
                    "price": "19,96",
                    "color": "#f299b9",
                    "l1": "M",
                    "l2": "G",
                    "url": "https://novexpert-lab.com/products/creme-douceur-hydro-biotique",
                    "cat" : "Magnésium"
                },
                "gel-purete": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/gel_purete_2K_5e19c9a6-867e-4368-98bb-37c70fe37b75_800x.webp?v=1704725557",
                    "titre": "Gel Pureté",
                    "benefices": "Anti-imperfections, Matifiant, Anti-rides",
                    "rating": "0",
                    "price": "21,56",
                    "color": "#51baad",
                    "l1": "Z",
                    "l2": "N",
                    "url": "https://novexpert-lab.com/products/gel-purete",
                    "cat" : "Trio-Zinc"
                },
                "le-gel-repulp": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/gel_repulp_2K_fec58788-b7c7-4e5b-8606-60769854cb33_800x.webp?v=1704728518",
                    "titre": "Le Gel Repulp",
                    "benefices": "Anti-âge, Fermeté, Peau rebondie",
                    "rating": "4.8",
                    "price": "31,96",
                    "color": "#be2664",
                    "l1": "H",
                    "l2": "A",
                    "url": "https://novexpert-lab.com/products/le-gel-repulp",
                    "cat" : "Acide hyaluronique"
                },
                "brume-magnesium": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/brume_magnesium_2K_f7374e11-ea71-495c-b16e-8f6240078152_800x.webp?v=1704727926",
                    "titre": "Brume Magnésium",
                    "benefices": "Hydrate, Calme, Protège",
                    "rating": "4.8",
                    "price": "7,96",
                    "color": "#f299b9",
                    "l1": "M",
                    "l2": "G",
                    "url": "https://novexpert-lab.com/products/brume-magnesium",
                    "cat" : "Magnésium"
                },
                "fluide-douceur-hydro-biotique": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/fluide_douceur_2K_ed687190-f9cd-447f-afb5-1ca2628dcf60_800x.webp?v=1704727961",
                    "titre": "Fluide Douceur Hydro-Biotique",
                    "benefices": "Apaise, Préserve, Protège",
                    "rating": "4.9",
                    "price": "19,96",
                    "color": "#f299b9",
                    "l1": "M",
                    "l2": "G",
                    "url": "https://novexpert-lab.com/products/fluide-douceur-hydro-biotique",
                    "cat" : "Magnésium"
                },
                "nettoyant-lacte": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/nettoyant_lacte_2K_9a2574c7-d0aa-4573-b8f7-fa21018f1a95_800x.webp?v=1704728025",
                    "titre": "Nettoyant Lacté Hydro-Biotique",
                    "benefices": "Lait Démaquillant, Nourrissant, Apaisant",
                    "rating": "4.9",
                    "price": "12,40",
                    "color": "#f299b9",
                    "l1": "M",
                    "l2": "G",
                    "url": "https://novexpert-lab.com/products/nettoyant-lacte",
                    "cat" : "Magnésium"
                },
                "baume-soin-demaquillant": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/baume_f98237b3-5ed8-43da-8446-9df087ddb090_800x.webp?v=1727367949",
                    "titre": "Baume Soin Démaquillant Pro-Rétinol",
                    "benefices": "Démaquillant, nettoyant, teint éclatant.",
                    "rating": "5",
                    "price": "18,32",
                    "color": "#614b79",
                    "l1": "R",
                    "l2": "E",
                    "url": "https://novexpert-lab.com/products/baume-soin-demaquillant",
                    "cat" : "Pro-Rétinol"
                },
                "brume-vitaminec": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/BACKGROUND_VITAMIN_C_MIST_800x.jpg?v=1741615211",
                    "titre": "Brume Vitamine C",
                    "benefices": "Eclat, Anti-Pollution, Anti-âge",
                    "rating": "5",
                    "price": "11,60",
                    "color": "#ec7802",
                    "l1": "V",
                    "l2": "C",
                    "url": "https://novexpert-lab.com/products/brume-vitaminec",
                    "cat" : "Vitamine C"
                },
                "creme-riche-protectrice": {
                    "img": "https://novexpert-lab.com/cdn/shop/files/creme_riche_2K_966e5067-ae75-42e7-8a10-69d85818fa00_800x.webp?v=1704727514",
                    "titre": "Crème Riche Protectrice",
                    "benefices": "Texture crème, Nutrition, Confort immédiat",
                    "rating": "0",
                    "price": "31,96",
                    "color": "#e5bf56",
                    "l1": "4.9",
                    "l2": "M",
                    "url": "https://novexpert-lab.com/products/creme-riche-protectrice",
                    "cat" : "Omégas"
                } 
            }
        }

        this.diagDataSmoon = { 
            "leger" : {
                "products" : ["string-menstruel-aphrodite-flux-leger","culotte-menstruelle-selene-flux-moyen","culotte-de-bain-menstruelle-ligie"]
            },
            "modere" : {
                "products" : ["culotte-menstruelle-selene-flux-moyen","culotte-menstruelle-artemis-flux-abondant","maillot-de-bain-menstruel-plage-nereides"]
            },
            "abondant" : {
                "products" : ["culotte-menstruelle-artemis-flux-abondant","culotte-menstruelle-hecate-flux-ultra-abondant","culotte-de-bain-menstruelle-heleades"]
            },
            "tres_abondant" : {
                "products" : ["culotte-menstruelle-artemis-flux-abondant","culotte-menstruelle-hecate-flux-ultra-abondant","culotte-menstruelle-detachable"]
            }
        };

        this.diagData = { 
            //ERUPTIONS/IMPERFECTIONS LOCALISEES
            "eruptions" : {
                "peau_grasse" : {
                    "products" : {
                        "nov" : ["gelee-moussante-peau-nette", "gel-purete", "stop-bouton-express"]
                    },
                    "explications" : `Les imperfections sont le résultat d'un engrenage mécanique précis : 
                        Hyper-séborrhée : vos glandes sébacées produisent trop de sébum.
                        Hyper-kératinisation : les cellules mortes, au lieu de s'éliminer, s'agglomèrent et forment un bouchon à la sortie du pore.
                        Cela la formation de boutons/comédons "blancs".
                        Cet environnement fermé, sans accès à l'oxygène, est propice au développement d'une bactérie, designée comme bactérie des imperfections : C.acnes.  Elle prolifère, et provoque une inflammation, ce qui provoque alors des boutons/comédons inflammés. 
                        Notre visage compte environ 20 000 pores, et donc autant de risque de voir se développer un bouton!`,
                    "recommandations" : `Quelques conseils pour retrouver pour prévenir & corriger les imperfections :
                        - Alimentation  : Limitez les sucres rapides (sodas, pain blanc, patisseries et gateaux transformés) et diminuez votre consommation de produits laitiers (surtout le lait). Les études scientifiques établissent un lieu direct entre sévérité des imperfections et leur consommation.
                        - Vie quotidienne : ne percez surtout pas les boutons. Cela brise le follicule et propage l'inflammation en profondeur, causant cicatrices et plus de boutons. Au besoin : utilisez un soin localisé - comme un Stop Bouton - pour agir localement sur le bouton sans le toucher.
                        - Cosmétique : cherchez les actifs sébo-régulateurs qui vont notamment limiter l'activité d'une molécule responsable de l'excès de sébum : la 5α-réductase : zinc, ortie, palmier nain, bakuchiol...`
                },
                "peau_mixte" : {
                    "products" : {
                        "nov" : ["gelee-moussante-peau-nette", "gel-purete", "stop-bouton-express"]
                    },
                    "explications" : `Les imperfections sont le résultat d'un engrenage mécanique précis : 
                        Hyper-séborrhée : vos glandes sébacées produisent trop de sébum.
                        Hyper-kératinisation : les cellules mortes, au lieu de s'éliminer, s'agglomèrent et forment un bouchon à la sortie du pore.
                        Cela la formation de boutons/comédons "blancs".
                        Cet environnement fermé, sans accès à l'oxygène, est propice au développement d'une bactérie, designée comme bactérie des imperfections : C.acnes.  Elle prolifère, et provoque une inflammation, ce qui provoque alors des boutons/comédons inflammés. 
                        Notre visage compte environ 20 000 pores, et donc autant de risque de voir se développer un bouton!`,
                    "recommandations" : `Quelques conseils pour retrouver pour prévenir & corriger les imperfections :
                        - Alimentation  : Limitez les sucres rapides (sodas, pain blanc, patisseries et gateaux transformés) et diminuez votre consommation de produits laitiers (surtout le lait). Les études scientifiques établissent un lieu direct entre sévérité des imperfections et leur consommation.
                        - Vie quotidienne : ne percez surtout pas les boutons. Cela brise le follicule et propage l'inflammation en profondeur, causant cicatrices et plus de boutons. Au besoin : utilisez un soin localisé - comme un Stop Bouton - pour agir localement sur le bouton sans le toucher.
                        - Cosmétique : cherchez les actifs sébo-régulateurs qui vont notamment limiter l'activité d'une molécule responsable de l'excès de sébum : la 5α-réductase : zinc, ortie, palmier nain, bakuchiol...`
                },
                "peau_seche" : {
                    "products" : {
                        "nov" : ["baume-soin-demaquillant", "gel-purete", "stop-bouton-express"]
                    },
                    "explications" : `Vous avez la peau sèche mais également des boutons. Ce duo déroutant s'explique par deux causes principales : une barrière cutanée défaillante et une inflammation chronique. Imaginez votre peau comme une forteresse. Quand ses murs (votre film hydrolipidique) sont fissurés par la sécheresse, elle perd son eau mais devient aussi perméable aux agressions et bactéries. Pour se défendre, elle surréagit par l'inflammation et produit un sébum aux lipides altérés. Cela provoque des boutons, notamment sur la zone T (du front au menton). 
                        Plusieurs études scientifiques ont montré que des peaux à imperfections manquaient d'un lipide clé au sein de la forteresse peau  : l'acide alpha-linolénique, un oméga 3. `,
                    "recommandations" : `Quelques conseils pour retrouver pour prévenir & corriger les imperfections sur votre peau sèche :
                        - Alimentation  : Limitez les sucres rapides (sodas, pain blanc, patisseries et gateaux transformés) et augmentez votre consommation de "bon lipides", notamment les omégas 3 :  EPA & DHA comme dans les petits poissons maquereaux, sardines, anchois… mais aussi ALA dans les grains de chia, huile de cameline, de lin etc. (en gardant bien ces huiles au frigo!)
                        - Vie quotidienne : ne percez surtout pas les boutons. Cela brise le follicule et propage l'inflammation en profondeur, causant cicatrices et plus de boutons. Au besoin : utilisez un soin localisé - comme un Stop Bouton - pour agir localement sur le bouton sans le toucher.
                        - Cosmétique : utilisez des nettoyants doux - comme un lait ou une huile - pour ne pas endommager votre barrière cutanée. Cherchez également des actifs apaisants et anti-inflammatoires comme le zinc, les omégas 3, la magnésium, les céramides etc.`
                },
                "peau_nc" : {
                    "products" : {
                        "nov" : ["gelee-moussante-peau-nette", "gel-purete", "stop-bouton-express"]
                    },
                    "explications" : `Les imperfections sont le résultat d'un engrenage mécanique précis : 
                        Hyper-séborrhée : vos glandes sébacées produisent trop de sébum.
                        Hyper-kératinisation : les cellules mortes, au lieu de s'éliminer, s'agglomèrent et forment un bouchon à la sortie du pore.
                        Cela la formation de boutons/comédons "blancs".
                        Cet environnement fermé, sans accès à l'oxygène, est propice au développement d'une bactérie, designée comme bactérie des imperfections : C.acnes.  Elle prolifère, et provoque une inflammation, ce qui provoque alors des boutons/comédons inflammés. 
                        Notre visage compte environ 20 000 pores, et donc autant de risque de voir se développer un bouton!`,
                    "recommandations" : `Quelques conseils pour retrouver pour prévenir & corriger les imperfections :
                        - Alimentation  : Limitez les sucres rapides (sodas, pain blanc, patisseries et gateaux transformés) et diminuez votre consommation de produits laitiers (surtout le lait). Les études scientifiques établissent un lieu direct entre sévérité des imperfections et leur consommation.
                        - Vie quotidienne : ne percez surtout pas les boutons. Cela brise le follicule et propage l'inflammation en profondeur, causant cicatrices et plus de boutons. Au besoin : utilisez un soin localisé - comme un Stop Bouton - pour agir localement sur le bouton sans le toucher.
                        - Cosmétique : cherchez les actifs sébo-régulateurs qui vont notamment limiter l'activité d'une molécule responsable de l'excès de sébum : la 5α-réductase : zinc, ortie, palmier nain, bakuchiol...`
                }
            },
            //"SECHERESSE/INCONFORT
            "secheresse" : {
                "peau_grasse" : {
                    "products" : {
                        "nov" : ["nettoyant-lacte", "brume-vitaminec", "fluide-purete"]
                    },
                    "explications" : `Votre peau est grasse mais tiraille, semble inconfortable. C'est surement le signe d'une déshydratation importante. Votre peau manque  d'EAU, pas de GRAS. Pour se défendre contre cette perte d'eau, elle déclenche un plan d'urgence : une surproduction de sébum pour créer un film "imperméable". Malheureusement, ce sébum de "crise" reste en surface, la fait briller, mais ne permet pas d'augmenter l'hydratation efficacement. 
                        D'autre part, si vous utilisez des nettoyants un peu trop agressifs, notamment pour réduire cette brillance, alors vous endommagez le film hydrolipidique, le bouclier naturel de votre peau. Cela augmente alors la déshydratation et la surproduction inutile de sébum par votre peau.`,
                    "recommandations" : `Quelques conseils pour retrouver renforcer votre barrière cutanée et améliorer l'hydratation de votre peau : 
                        - Alimentation : choisissez  des aliments riches en oméga 3 pour venir renforcer la barrière cutanée : EPA & DHA comme dans les petits poissons maquereaux, sardines, anchois… mais aussi ALA dans les grains de chia, huile de cameline, de lin etc. (en gardant bien ces huiles au frigo!)
                        Buvez de l'eau (minimum 1,5L par jour = 3 gourdes de 500mL à préparer pour la journée) et consommez des aliments riches en eau : pastèque, concombre, tomates etc. 
                        - Vie quotidienne : limitez le stress par le moyen le plus efficace pour vous : activité sportive, yoga, respiration profonde etc. La production de cortisol (libéré en cas de stress), stimule également la production de sébum.
                        -  Cosmétique : utilisez des nettoyants doux et surtout pas décapants (ou trop moussants) pour ne pas abimer la barrière lipidique. Préférez les huiles ou  laits nettoyants par exemple. 
                        Ajoutez des actifs hydratants comme l'acide hyaluronique.`
                },
                "peau_mixte" : {
                    "products" : {
                        "nov" : ["huile-demaquillante-aux-5-omegas", "serum-booster-acide-hyaluronique", "la-creme-repulp"]
                    },
                    "explications" : `La sensation d'inconfort, de tiraillement est due à  un manque de lipides essentiels (notamment céramides, omégas) qui agissent comme un "ciment" souple entre vos cellules. Sans ce ciment, la peau perd son élasticité, elle est moins souple et tiraille , comme un vêtement qui aurait rétréci au lavage. Certains mouvements créent alors une tension désagréable.  Et ce n'est pas fini. Une peau sèche, qui manque de lipides, est soucent une peau déshydratée. L'eau s'évapore beaucoup plus facilement car la barrière est altérée. 
                        L'objectif est donc de nourrir votre peau avec ces lipides essentiels pour reformer votre barrière hydro-lipidique et renforcer le ciment cutané, mais aussi de favoriser une meilleure hydratation.`,
                    "recommandations" : `Quelques conseils pour retrouver renforcer votre barrière cutanée et retrouver une peau souple et confortable : 
                        - Alimentation : choisissez  des aliments riches en oméga 3 pour venir renforcer la barrière cutanée : EPA & DHA comme dans les petits poissons maquereaux, sardines, anchois… mais aussi ALA dans les grains de chia, huile de cameline, de lin etc. (en gardant bien ces huiles au frigo!)
                        Buvez de l'eau (minimum 1,5L par jour = 3 gourdes de 500mL à préparer pour la journée) et consommez des aliments riches en eau : pastèque, concombre, tomates etc. 
                        - Vie quotidienne: évitez les atmosphères surchauffées et sèches. Utilisez un humidificateur au besoin (humidité idéale : 45-65%) et munissez-vous d'une brume, à l'acide hyaluronique notamment, pour les environnements secs comme au bureau avec l'air conditionné ou dans l'avion.
                        -  Cosmétique : utilisez des nettoyants doux et surtout pas décapants (ou trop moussants) pour ne pas abimer la barrière lipidique. Préférez les huiles ou  laits nettoyants par exemple. 
                        Ajoutez des actifs hydratants comme l'acide hyaluronique.`
                },
                "peau_seche" : {
                    "products" : {
                        "nov" : ["huile-demaquillante-aux-5-omegas", "serum-booster-acide-hyaluronique", "creme-riche-protectrice"]
                    },
                    "explications" : `La sensation d'inconfort, de tiraillement est due à  un manque de lipides essentiels (notamment céramides, omégas) qui agissent comme un "ciment" souple entre vos cellules. Sans ce ciment, la peau perd son élasticité, elle est moins souple et tiraille , comme un vêtement qui aurait rétréci au lavage. Certains mouvements créent alors une tension désagréable.  Et ce n'est pas fini. Une peau sèche, qui manque de lipides, est soucent une peau déshydratée. L'eau s'évapore beaucoup plus facilement car la barrière est altérée. 
                        L'objectif est donc de nourrir votre peau avec ces lipides essentiels pour reformer votre barrière hydro-lipidique et renforcer le ciment cutané, mais aussi de favoriser une meilleure hydratation.`,
                    "recommandations" : `Quelques conseils pour retrouver renforcer votre barrière cutanée et retrouver une peau souple et confortable : 
                        - Alimentation : choisissez  des aliments riches en oméga 3 pour venir renforcer la barrière cutanée : EPA & DHA comme dans les petits poissons maquereaux, sardines, anchois… mais aussi ALA dans les grains de chia, huile de cameline, de lin etc. (en gardant bien ces huiles au frigo!)
                        Buvez de l'eau (minimum 1,5L par jour = 3 gourdes de 500mL à préparer pour la journée) et consommez des aliments riches en eau : pastèque, concombre, tomates etc. 
                        - Vie quotidienne: évitez les atmosphères surchauffées et sèches. Utilisez un humidificateur au besoin (humidité idéale : 45-65%) et munissez-vous d'une brume, à l'acide hyaluronique notamment, pour les environnements secs comme au bureau avec l'air conditionné ou dans l'avion.
                        -  Cosmétique : utilisez des nettoyants doux et surtout pas décapants (ou trop moussants) pour ne pas abimer la barrière lipidique. Préférez les huiles ou  laits nettoyants par exemple. 
                        Ajoutez des actifs hydratants comme l'acide hyaluronique.`
                },
                "peau_nc" : {
                    "products" : {
                        "nov" : ["huile-demaquillante-aux-5-omegas", "serum-booster-acide-hyaluronique", "creme-riche-protectrice"]
                    },
                    "explications" : `La sensation d'inconfort, de tiraillement est due à  un manque de lipides essentiels (notamment céramides, omégas) qui agissent comme un "ciment" souple entre vos cellules. Sans ce ciment, la peau perd son élasticité, elle est moins souple et tiraille , comme un vêtement qui aurait rétréci au lavage. Certains mouvements créent alors une tension désagréable.  Et ce n'est pas fini. Une peau sèche, qui manque de lipides, est soucent une peau déshydratée. L'eau s'évapore beaucoup plus facilement car la barrière est altérée. 
                        L'objectif est donc de nourrir votre peau avec ces lipides essentiels pour reformer votre barrière hydro-lipidique et renforcer le ciment cutané, mais aussi de favoriser une meilleure hydratation.`,
                    "recommandations" : `Quelques conseils pour retrouver renforcer votre barrière cutanée et retrouver une peau souple et confortable : 
                        - Alimentation : choisissez  des aliments riches en oméga 3 pour venir renforcer la barrière cutanée : EPA & DHA comme dans les petits poissons maquereaux, sardines, anchois… mais aussi ALA dans les grains de chia, huile de cameline, de lin etc. (en gardant bien ces huiles au frigo!)
                        Buvez de l'eau (minimum 1,5L par jour = 3 gourdes de 500mL à préparer pour la journée) et consommez des aliments riches en eau : pastèque, concombre, tomates etc. 
                        - Vie quotidienne: évitez les atmosphères surchauffées et sèches. Utilisez un humidificateur au besoin (humidité idéale : 45-65%) et munissez-vous d'une brume, à l'acide hyaluronique notamment, pour les environnements secs comme au bureau avec l'air conditionné ou dans l'avion.
                        -  Cosmétique : utilisez des nettoyants doux et surtout pas décapants (ou trop moussants) pour ne pas abimer la barrière lipidique. Préférez les huiles ou  laits nettoyants par exemple. 
                        Ajoutez des actifs hydratants comme l'acide hyaluronique.`
                }
            },
            //"BRILLANCE EXCESSIVE/EXCES DE SEBUM
            "brillance" : {
                "peau_grasse" : {
                    "products" : {
                        "nov" : ["mousse-nettoyante-flash-eclat", "brume-trio-zinc", "gel-purete"]
                    },
                    "explications" : `Une peau brillante est due à un excès de sébum, ce liquide constitué de lipides produits par vos glandes sébacées. Au cœur de cette surproduction de sébum se trouve une molécule bien spécifique :   la 5-alpha réductase. Elle transforme certaines hormones en un puissant stimulant qui ordonne à vos glandes sébacées de produire du sébum en continu.  Le stress, la chaleur, certains aliments (notamment produits sucrés et laitiers) peuvent amplifier ce signal, transformant vos glandes en petites usines surproductives. En surface, l'effet est quasi-immédiat : une peau brillante, luisante, que l'on souhaite matifier par tous les moyens.`,
                    "recommandations" : `Quelques conseils pour limiter cet excès de sébum :
                        - Alimentation : diminuez fortement le sucre (sodas, jus de fruits, pain blanc, pâtisserie, sucre en poudre, alcool…) et les produits laitiers (surtout le lait). A l'inverse, gavoriser les aliments riches en zinc (foie de veau, huitres, bœuf...)
                        - Vie quotidienne : limitez le stress par le moyen le plus efficace pour vous : activité sportive, yoga, respiration profonde etc. La production de cortisol (libéré en cas de stress), stimule également la production de sébum.
                        - Cosmétique : cherchez les actifs sébo-régulateurs qui vont notamment limiter l'activité d'une molécule responsable de l'excès de sébum : la 5α-réductase : zinc, ortie, palmier nain, bakuchiol...`
                },
                "peau_mixte" : {
                    "products" : {
                        "nov" : ["mousse-nettoyante-flash-eclat", "brume-trio-zinc", "gel-purete"]
                    },
                    "explications" : `Une peau brillante est due à un excès de sébum, ce liquide constitué de lipides produits par vos glandes sébacées. Au cœur de cette surproduction de sébum se trouve une molécule bien spécifique :   la 5-alpha réductase. Elle transforme certaines hormones en un puissant stimulant qui ordonne à vos glandes sébacées de produire du sébum en continu.  Le stress, la chaleur, certains aliments (notamment produits sucrés et laitiers) peuvent amplifier ce signal, transformant vos glandes en petites usines surproductives. En surface, l'effet est quasi-immédiat : une peau brillante, luisante, que l'on souhaite matifier par tous les moyens.`,
                    "recommandations" : `Quelques conseils pour limiter cet excès de sébum :
                        - Alimentation : diminuez fortement le sucre (sodas, jus de fruits, pain blanc, pâtisserie, sucre en poudre, alcool…) et les produits laitiers (surtout le lait). A l'inverse, gavoriser les aliments riches en zinc (foie de veau, huitres, bœuf...)
                        - Vie quotidienne : limitez le stress par le moyen le plus efficace pour vous : activité sportive, yoga, respiration profonde etc. La production de cortisol (libéré en cas de stress), stimule également la production de sébum.
                        - Cosmétique : cherchez les actifs sébo-régulateurs qui vont notamment limiter l'activité d'une molécule responsable de l'excès de sébum : la 5α-réductase : zinc, ortie, palmier nain, bakuchiol...`
                },
                "peau_seche" : {
                    "products" : {
                        "nov" : ["nettoyant-lacte", "brume-trio-zinc", "gel-purete"] 
                    },
                    "explications" : `Votre peau semble sèche, tire mais brille ? Ce sont des signaux à ne pas ignorer. Votre barrière cutanée est abîmée, destructurée. Elle manque de bons lipides pour assurer la solidité et la cohésion. Conséquence directe : elle doit également être déshydratée. La perte insensible en eau peut augmenter de plus de 75% en cas de barrière cutanée altérée.
                        Pour se protéger de cette perte d'eau et compenser une barrière cutanée défaillante, elle surproduit du sébum en "mode panique". Ce sébum n'a pas pour but de nourrir, mais de créer un film "waterproof" temporaire. Sa composition est pauvre en bons lipides comme les omégas,  il reste en surface et brille, sans jamais nourrir réellement la peau ni éviter une déshydratation programmée. `,
                    "recommandations" : `Quelques conseils pour réparer votre barrière cutanée et éviter cet apport excessif et inutile de sébum :
                        - Alimentation : choisissez  des aliments riches en oméga 3 pour venir renforcer la barrière cutanée : EPA & DHA comme dans les petits poissons maquereaux, sardines, anchois… mais aussi ALA dans les grains de chia, huile de cameline, de lin etc. (en gardant bien ces huiles au frigo!)
                        Buvez de l'eau (minimum 1,5L par jour = 3 gourdes de 500mL à préparer pour la journée) et consommez des aliments riches en eau : pastèque, concombre, tomates etc. 
                        - Vie quotidienne: protégez vous des agressions extérieures comme le soleil (protection solaire si exposition de plus de 20 min), de la pollution (soins anti-pollution, nettoyage doux et efficace), préférez les brumes à l'eau du robinet etc.
                        - Cosmétique : utilisez des nettoyants doux et surtout pas décapants (ou trop moussants) pour ne pas abimer la barrière lipidique. Préférez les huiles ou  laits nettoyants par exemple, et évitez surtout les tensioactifs finissant en "sulfates". `
                },
                "peau_nc" : {
                    "products" : {
                        "nov" : ["mousse-nettoyante-flash-eclat", "brume-trio-zinc", "gel-purete"]
                    },
                    "explications" : `Une peau brillante est due à un excès de sébum, ce liquide constitué de lipides produits par vos glandes sébacées. Au cœur de cette surproduction de sébum se trouve une molécule bien spécifique :   la 5-alpha réductase. Elle transforme certaines hormones en un puissant stimulant qui ordonne à vos glandes sébacées de produire du sébum en continu.  Le stress, la chaleur, certains aliments (notamment produits sucrés et laitiers) peuvent amplifier ce signal, transformant vos glandes en petites usines surproductives. En surface, l'effet est quasi-immédiat : une peau brillante, luisante, que l'on souhaite matifier par tous les moyens.`,
                    "recommandations" : `Quelques conseils pour limiter cet excès de sébum :
                        - Alimentation : diminuez fortement le sucre (sodas, jus de fruits, pain blanc, pâtisserie, sucre en poudre, alcool…) et les produits laitiers (surtout le lait). A l'inverse, gavoriser les aliments riches en zinc (foie de veau, huitres, bœuf...)
                        - Vie quotidienne : limitez le stress par le moyen le plus efficace pour vous : activité sportive, yoga, respiration profonde etc. La production de cortisol (libéré en cas de stress), stimule également la production de sébum.
                        - Cosmétique : cherchez les actifs sébo-régulateurs qui vont notamment limiter l'activité d'une molécule responsable de l'excès de sébum : la 5α-réductase : zinc, ortie, palmier nain, bakuchiol...`
                }
            },
            //SENSIBILITE/INFLAMMATION
            "sensibilite" : {
                "peau_grasse" : {
                    "products" : {
                        "nov" : ["nettoyant-lacte", "brume-magnesium", "gel-purete"]
                    },
                    "explications" : `Une peau grasse et sensible est souvent la conséquence d'une mauvaise qualité de sébum. Des publications scientifiques récentes montrent que le sébum des peaux grasses et sensibles est souvent déséquilibré : il manque d'acides gras essentiels apaisants (acide linolénique) et est trop riche en composés irritants (acide oléique, squalène oxydé). Ce sébum de "mauvaise qualité" irrite la peau de l'intérieur, entretient une micro-inflammation permanente et la rend hyper-réactive à tout.
                        Aujourd'hui, 60% des femmes déclarent avoir la peau sensible. Ce chiffre impressionnant a doublé en 20 ans et touche tous les types de peaux.`,
                    "recommandations" : `Quelques conseils pour apaiser votre peau : 
                        - Alimentation : privilégiez les aliments anti-inflammatoires et antioxydants comme les Omégas 3 (petits poissons pour EPA + DHA, graines de chia, huile de lin pour ALA), le thé vert, le curcuma, certains fruits rouges comme la myrtille.
                        Limitez les sucres rapides et les produits laitiers, qui favorisent la production d'un sébum pro-inflammatoire.
                        - Vie quoditienne : évitez les bains chauds, préférez les douches tièdes (27-30°C) et utilisez un pommeau de douche filtrant l'eau (pour limiter chlore et calcaire). Pour le visage, préférez les brumes à l'eau du robinet. 
                        - Cosmétique: évitez les nettoyants moussants - préférez les laits ou huiles. 
                        Limitez l’utilisation de produits à base d’alcool (Alcohol, Benzyl Alcohol) qui assèchent la peau et les ingrédients dérivés d’hydrocarbures (Paraffinum Liquidum, Petrolatum, Cera Microcristallina, Ozokerite, Ceresin, Mineral oil...) qui auront un effet uniquement à court terme.`
                },
                "peau_mixte" : {
                    "products" : {
                        "nov" : ["nettoyant-lacte", "brume-magnesium", "fluide-douceur-hydro-biotique"]
                    },
                    "explications" : `Votre peau semble sensible, elle réagit aux changements de température, aux nouveaux soins cosmétiques ou lors de changements d'environnements ? Cela est notamment du au lien étroit qu'entretient votre peau avec votre cerveau depuis la naissance. Votre peau est dotée d'un réseau de milliers de capteurs nerveux. D'après les chercheurs, sur une peau sensible, ces capteurs sont hyper-réactifs : leur seuil de tolérance est abaissé. Ils sonnent l'alarme (rougeurs, picotements) pour des événements mineurs, comme un simple changement de température ou une émotion. Votre peau est en état d'alerte permanent, et se trouve dans un état d'inflammation quasi constant.
                        Aujourd'hui, 60% des femmes déclarent avoir la peau sensible. Ce chiffre impressionnant a doublé en 20 ans.`,
                    "recommandations" : `Quelques conseils pour apaiser votre peau : 
                        - Alimentation : privilégiez les aliments anti-inflammatoires et antioxydants comme les Omégas 3 (petits poissons pour EPA + DHA, graines de chia, huile de lin pour ALA), le thé vert, le curcuma, certains fruits rouges comme la myrtille.
                        Cherchez aussi les aliments riches en magnésium : cacao (sans sucres), graines de courges, amandes, lentilles, pois chiches etc.
                        - Vie quoditienne : évitez les bains chauds, préférez les douches tièdes (27-30°C) et utilisez un pommeau de douche filtrant l'eau (pour limiter chlore et calcaire). Pour le visage, préférez les brumes à l'eau du robinet. 
                        - Cosmétique: évitez les nettoyants moussants - préférez les laits ou huiles. 
                        Limitez l’utilisation de produits à base d’alcool (Alcohol, Benzyl Alcohol) qui assèchent la peau et les ingrédients dérivés d’hydrocarbures (Paraffinum Liquidum, Petrolatum, Cera Microcristallina, Ozokerite, Ceresin, Mineral oil...) qui auront un effet uniquement à court terme.`
                },
                "peau_seche" : {
                    "products" : {
                        "nov" : ["nettoyant-lacte", "brume-magnesium", "creme-douceur-hydro-biotique"]
                    },
                    "explications" : `Votre peau semble sensible, elle réagit aux changements de température, aux nouveaux soins cosmétiques ou lors de changements d'environnements ? Cela est notamment du au lien étroit qu'entretient votre peau avec votre cerveau depuis la naissance. Votre peau est dotée d'un réseau de milliers de capteurs nerveux. D'après les chercheurs, sur une peau sensible, ces capteurs sont hyper-réactifs : leur seuil de tolérance est abaissé. Ils sonnent l'alarme (rougeurs, picotements) pour des événements mineurs, comme un simple changement de température ou une émotion. Votre peau est en état d'alerte permanent, et se trouve dans un état d'inflammation quasi constant.
                        Aujourd'hui, 60% des femmes déclarent avoir la peau sensible. Ce chiffre impressionnant a doublé en 20 ans.`,
                    "recommandations" : `Quelques conseils pour apaiser votre peau : 
                        - Alimentation : privilégiez les aliments anti-inflammatoires et antioxydants comme les Omégas 3 (petits poissons pour EPA + DHA, graines de chia, huile de lin pour ALA), le thé vert, le curcuma, certains fruits rouges comme la myrtille.
                        Cherchez aussi les aliments riches en magnésium : cacao (sans sucres), graines de courges, amandes, lentilles, pois chiches etc.
                        - Vie quoditienne : évitez les bains chauds, préférez les douches tièdes (27-30°C) et utilisez un pommeau de douche filtrant l'eau (pour limiter chlore et calcaire). Pour le visage, préférez les brumes à l'eau du robinet. 
                        - Cosmétique: évitez les nettoyants moussants - préférez les laits ou huiles. 
                        Limitez l’utilisation de produits à base d’alcool (Alcohol, Benzyl Alcohol) qui assèchent la peau et les ingrédients dérivés d’hydrocarbures (Paraffinum Liquidum, Petrolatum, Cera Microcristallina, Ozokerite, Ceresin, Mineral oil...) qui auront un effet uniquement à court terme.`
                },
                "peau_nc" : {
                    "products" : {
                        "nov" : ["nettoyant-lacte", "brume-magnesium", "fluide-douceur-hydro-biotique"]
                    },
                    "explications" : `Votre peau semble sensible, elle réagit aux changements de température, aux nouveaux soins cosmétiques ou lors de changements d'environnements ? Cela est notamment du au lien étroit qu'entretient votre peau avec votre cerveau depuis la naissance. Votre peau est dotée d'un réseau de milliers de capteurs nerveux. D'après les chercheurs, sur une peau sensible, ces capteurs sont hyper-réactifs : leur seuil de tolérance est abaissé. Ils sonnent l'alarme (rougeurs, picotements) pour des événements mineurs, comme un simple changement de température ou une émotion. Votre peau est en état d'alerte permanent, et se trouve dans un état d'inflammation quasi constant.
                        Aujourd'hui, 60% des femmes déclarent avoir la peau sensible. Ce chiffre impressionnant a doublé en 20 ans.`,
                    "recommandations" : `Quelques conseils pour apaiser votre peau : 
                        - Alimentation : privilégiez les aliments anti-inflammatoires et antioxydants comme les Omégas 3 (petits poissons pour EPA + DHA, graines de chia, huile de lin pour ALA), le thé vert, le curcuma, certains fruits rouges comme la myrtille.
                        Cherchez aussi les aliments riches en magnésium : cacao (sans sucres), graines de courges, amandes, lentilles, pois chiches etc.
                        - Vie quoditienne : évitez les bains chauds, préférez les douches tièdes (27-30°C) et utilisez un pommeau de douche filtrant l'eau (pour limiter chlore et calcaire). Pour le visage, préférez les brumes à l'eau du robinet. 
                        - Cosmétique: évitez les nettoyants moussants - préférez les laits ou huiles. 
                        Limitez l’utilisation de produits à base d’alcool (Alcohol, Benzyl Alcohol) qui assèchent la peau et les ingrédients dérivés d’hydrocarbures (Paraffinum Liquidum, Petrolatum, Cera Microcristallina, Ozokerite, Ceresin, Mineral oil...) qui auront un effet uniquement à court terme.`
                }
            },
            //TEINT TERNE/BROUILLE
            "teint_terne" : {
                "peau_grasse" : {
                    "products" : {
                        "nov" : ["mousse-nettoyante-flash-eclat", "brume-vitaminec", "booster-a-la-vitamine-c"]
                    },
                    "explications" : `Votre peau  semble grasse mais manque d'éclat.  C'est un paradoxe qui s'explique à l'échelle cutanée. 
                        Imaginez votre peau comme un miroir. Pour qu’il renvoie parfaitement la lumière (teint éclatant), sa surface doit être lisse. Or, une peau grasse a souvent un micro-relief irrégulier : les pores sont dilatés et un surplus de cellules mortes s’accumule, "collées" par l’excès de sébum. Nous perdons environ 4 kg de cellules mortes par an et sur une peau grasse, leur élimination est ralentie. La surface cutanée devient alors irrégulire et ne réfléchit plus la lumière mais la diffuse dans toutes les directions, créant une impression de voile terne, comme un miroir dépoli. `,
                    "recommandations" : `Quelques conseils pour retrouver de l'éclat :
                        - Alimentation : privilégiez les aliments "bonne mine" contenant du bêta-carotène : chou frisé, patate douce, carotte etc.
                        De manière générale, mangez les fruits et les légumes crus dès que vous le pouvez ou préférez les cuissons douces : à la vapeur par exemple.
                        - Vie quotidienne : éteindre les écrans 1 h avant de dormir et ne pas se coucher après 23h si possible, 60 % des adultes dormant moins de 7 h ont un teint plus terne.
                        - Cosmétique : Utilisez des exfoliants doux (type AHA comme l'acide lactique ou PHA comme la gluconolactone) pour lisser le grain de peau et "décoller" les cellules mortes.`
                },
                "peau_mixte" : {
                    "products" : {
                        "nov" : ["mousse-nettoyante-flash-eclat", "brume-vitaminec", "booster-a-la-vitamine-c"]
                    },
                    "explications" : `La peau peut perdre de son éclat à cause de ce certains scientifiques appellent le "burn-out" cellulaire. Le stress, la fatigue ou la pollution ralentissent le rythme de renouvellement de votre épiderme, la première couche de la peau. En effet, dès 30 ans, le renouvellement peut ralentir de 25 à 30%, passant de 28 à près de 40 jours.  Cela créé un  "embouteillage" de cellules mortes en surface. Ces cellules, ternes et opaques, empêchent une bonne réflexion de la lumière, ce qui se traduit en surface par un "teint terne". 
                        Une seconde cause du teint terne souvent évoquée par les chercheurs en biologie cutanée est un ralentissement de la microcirculation sanguine du au froid, à la fatigue ou au tabac par exemple.`,
                    "recommandations" : `
                        Quelques conseils pour retrouver de l'éclat :
                        - Alimentation : privilégiez les aliments "bonne mine" contenant du bêta-carotène : chou frisé, patate douce, carotte etc.
                        De manière générale, mangez les fruits et les légumes crus dès que vous le pouvez ou préférez les cuissons douces : à la vapeur par exemple.
                        - Vie quotidienne :éteindre les écrans 1 h avant de dormir et ne pas se coucher après 23h si possible, 60 % des adultes dormant moins de 7 h ont un teint plus terne.
                        - Cosmétique : Utilisez des exfoliants doux (type AHA comme l'acide lactique ou PHA comme la gluconolactone) pour lisser le grain de peau et "décoller" les cellules mortes.`
                },
                "peau_seche" : {
                    "products" : {
                        "nov" : ["baume-soin-demaquillant", "brume-vitaminec", "booster-a-la-vitamine-c"]
                    },
                    "explications" : `Une peau sèche a souvent tendance à être plus déshydratée et à perdre de son éclat. Cela s'explique tout simplement par la structure de votre peau.
                        Imaginez votre surface cutanée comme un mur de briques (vos cellules) lié par un ciment (vos lipides). Sur une peau sèche, ce ciment lipidique est de mauvaise qualité et/ou en quantité insuffisante. Les briques sont alors désorganisées, le mur se fissure. Cette surface irrégulière et poreuse, ne retient plus l'eau  et ne peut plus réfléchir la lumière correctement. Cele créé un voile terne et votre peau semble manquer d'éclat.`,
                    "recommandations" : `Quelques conseils pour retrouver de l'éclat et réduire la sécheresse de votre peau :
                        - Alimentation : privilégiez les aliments "bonne mine" contenant du bêta-carotène : chou frisé, patate douce, carotte etc.
                        Choisissez aussi des aliments riches en oméga 3 pour venir renforcer la barrière cutanée : EPA & DHA comme dans les petits poissons maquereaux, sardines, anchois… mais aussi ALA dans les grains de chia, huile de cameline, de lin etc. (en gardant bien ces huiles au frigo!)
                        - Vie quotidienne :  éteindre les écrans 1 h avant de dormir et ne pas se coucher après 23h si possible, 60 % des adultes dormant moins de 7 h ont un teint plus terne.
                        - Cosmétique : utilisez des nettoyants doux et surtout pas décapants (ou trop moussants) pour ne pas abimer la barrière lipidique. Préférez les huiles ou  laits nettoyants par exemple.`
                },
                "peau_nc" : {
                    "products" : {
                        "nov" : ["mousse-nettoyante-flash-eclat", "brume-vitaminec", "booster-a-la-vitamine-c"]
                    },
                    "explications" : `La peau peut perdre de son éclat à cause de ce certains scientifiques appellent le "burn-out" cellulaire. Le stress, la fatigue ou la pollution ralentissent le rythme de renouvellement de votre épiderme, la première couche de la peau. En effet, dès 30 ans, le renouvellement peut ralentir de 25 à 30%, passant de 28 à près de 40 jours.  Cela créé un  "embouteillage" de cellules mortes en surface. Ces cellules, ternes et opaques, empêchent une bonne réflexion de la lumière, ce qui se traduit en surface par un "teint terne". 
                        Une seconde cause du teint terne souvent évoquée par les chercheurs en biologie cutanée est un ralentissement de la microcirculation sanguine du au froid, à la fatigue ou au tabac par exemple.`,
                    "recommandations" : `Quelques conseils pour retrouver de l'éclat :
                        - Alimentation : privilégiez les aliments "bonne mine" contenant du bêta-carotène : chou frisé, patate douce, carotte etc.
                        - Vie quotidienne : éteindre les écrans 1 h avant de dormir et ne pas se coucher après 23h si possible, 60 % des adultes dormant moins de 7 h ont un teint plus terne.
                        - Cosmétique : Utilisez des exfoliants doux (type AHA comme l'acide lactique ou PHA comme la gluconolactone) pour lisser le grain de peau et "décoller" les cellules mortes.`
                }
            },
            //AUCUN CHANGEMENT
            "nc" : {
                "peau_grasse" : {
                    "products" : {
                        "nov" : ["mousse-nettoyante-flash-eclat", "brume-vitaminec", "gel-purete"]
                    },
                    "explications" : `Une peau grasse est due à un excès de sébum, ce liquide constitué de lipides produits par vos glandes sébacées. Au cœur de cette surproduction de sébum se trouve une molécule bien spécifique :   la 5-alpha réductase. Elle transforme certaines hormones en un puissant stimulant qui ordonne à vos glandes sébacées de produire du sébum en continu.  Le stress, la chaleur, certains aliments (notamment produits sucrés et laitiers) peuvent amplifier ce signal, transformant vos glandes en petites usines surproductives. En surface, l'effet est quasi-immédiat : une peau brillante, luisante, que l'on souhaite matifier par tous les moyens.`,
                    "recommandations" : `Quelques conseils pour limiter cet excès de sébum :
                        - Alimentation : diminuez fortement le sucre (sodas, jus de fruits, pain blanc, pâtisserie, sucre en poudre, alcool…) et les produits laitiers (surtout le lait). A l'inverse, gavoriser les aliments riches en zinc (foie de veau, huitres, bœuf...)
                        - Vie quotidienne : limitez le stress par le moyen le plus efficace pour vous : activité sportive, yoga, respiration profonde etc. La production de cortisol (libéré en cas de stress), stimule également la production de sébum.
                        - Cosmétique : cherchez les actifs sébo-régulateurs qui vont notamment limiter l'activité d'une molécule responsable de l'excès de sébum : la 5α-réductase : zinc, ortie, palmier nain, bakuchiol...`
                },
                "peau_mixte" : {
                    "products" : {
                        "nov" : ["mousse-nettoyante-flash-eclat", "booster-a-la-vitamine-c", "le-gel-repulp"]
                    },
                    "explications" : `Une peau semble équilibrée : elle maîtrise l'art de s'auto-réguler. Son film hydrolipidique (le juste équilibre eau/gras) est fonctionnel, son pH est idéalement acide, et son renouvellement cellulaire se fait de manière régulière. Elle fonctionne comme un orchestre biologique où chaque musicien joue sa partition à la perfection. Le défi n'est pas de la changer, mais de perpétuer ce fragile et précieux équilibre en apportant la juste dose de lipides, d'actifs hydratants  et antioxydants.`,
                    "recommandations" : `Nos conseils pour préserver cet équilibre cutané : 
                        - Alimentation : misez sur l'alimentation colorée! Fruits et légumes de différentes couleurs sont riches en antioxydants et composés anti-inflammatoires. Privilégiez une consommation crue ou une cuisson douce (comme la vapeur) pour en conserver tous les bienfaits. Accompagnez vos crudités d'un filet d'huile de lin ou de cameline pour augmenter l'absorption des nutriments.
                        - Rythme de vie : maintenez un sommeil de qualité. Cela est clé, notamment pour le renouvellement cellulaire. Une étude a notamment montré que 60 % des adultes dormant moins de 7 h ont un teint plus terne.
                        - Cosmétique : Less is more. Priviléfiez des soins 2-en-1 : anti-âge et hydratant par exemple pour ne pas surcharger votre peau. Faites des gommages suivis de masques 1 à 2 fois par semaine pour entretenir le rythme de renouvellement de votre peau.`
                },
                "peau_seche" : {
                    "products" : {
                        "nov" : ["baume-soin-demaquillant", "serum-booster-acide-hyaluronique", "creme-riche-protectrice"]
                    },
                    "explications" : `La sensation de sécheresse, de tiraillement est due à  un manque de lipides essentiels (notamment céramides, omégas) qui agissent comme un "ciment" souple entre vos cellules. Sans ce ciment, la peau perd son élasticité, elle est moins souple et tiraille , comme un vêtement qui aurait rétréci au lavage. Certains mouvements créent alors une tension désagréable.  Et ce n'est pas fini. Une peau sèche, qui manque de lipides, est soucent une peau déshydratée. L'eau s'évapore beaucoup plus facilement car la barrière est altérée. 
                        L'objectif est donc de nourrir votre peau avec ces lipides essentiels pour reformer votre barrière hydro-lipidique et renforcer le ciment cutané, mais aussi de favoriser une meilleure hydratation.`,
                    "recommandations" : `Quelques conseils pour retrouver renforcer votre barrière cutanée et retrouver une peau souple et confortable : 
                        - Alimentation : choisissez  des aliments riches en oméga 3 pour venir renforcer la barrière cutanée : EPA & DHA comme dans les petits poissons maquereaux, sardines, anchois… mais aussi ALA dans les grains de chia, huile de cameline, de lin etc. (en gardant bien ces huiles au frigo!)
                        Buvez de l'eau (minimum 1,5L par jour = 3 gourdes de 500mL à préparer pour la journée) et consommez des aliments riches en eau : pastèque, concombre, tomates etc. 
                        - Vie quotidienne: évitez les atmosphères surchauffées et sèches. Utilisez un humidificateur au besoin (humidité idéale : 45-65%) et munissez-vous d'une brume, à l'acide hyaluronique notamment, pour les environnements secs comme au bureau avec l'air conditionné ou dans l'avion.
                        -  Cosmétique : utilisez des nettoyants doux et surtout pas décapants (ou trop moussants) pour ne pas abimer la barrière lipidique. Préférez les huiles ou  laits nettoyants par exemple. 
                        Ajoutez des actifs hydratants comme l'acide hyaluronique.`
                },
                "peau_nc" : {
                    "products" : {
                        "nov" : ["mousse-nettoyante-flash-eclat", "booster-a-la-vitamine-c", "la-creme-repulp"]
                    },
                    "explications" : `Une peau semble équilibrée : elle maîtrise l'art de s'auto-réguler. Son film hydrolipidique (le juste équilibre eau/gras) est fonctionnel, son pH est idéalement acide, et son renouvellement cellulaire se fait de manière régulière. Elle fonctionne comme un orchestre biologique où chaque musicien joue sa partition à la perfection. Le défi n'est pas de la changer, mais de perpétuer ce fragile et précieux équilibre en apportant la juste dose de lipides, d'actifs hydratants  et antioxydants.`,
                    "recommandations" : `Nos conseils pour préserver cet équilibre cutané : 
                        - Alimentation : misez sur l'alimentation colorée! Fruits et légumes de différentes couleurs sont riches en antioxydants et composés anti-inflammatoires. Privilégiez une consommation crue ou une cuisson douce (comme la vapeur) pour en conserver tous les bienfaits. Accompagnez vos crudités d'un filet d'huile de lin ou de cameline pour augmenter l'absorption des nutriments.
                        - Rythme de vie : maintenez un sommeil de qualité. Cela est clé, notamment pour le renouvellement cellulaire. Une étude a notamment montré que 60 % des adultes dormant moins de 7 h ont un teint plus terne.
                        - Cosmétique : Less is more. Priviléfiez des soins 2-en-1 : anti-âge et hydratant par exemple pour ne pas surcharger votre peau. Faites des gommages suivis de masques 1 à 2 fois par semaine pour entretenir le rythme de renouvellement de votre peau.`
                }
            } 
        }
 

        document.addEventListener('keyup', (e) => {
            if(e.code == "Enter" && document.querySelectorAll(".content-diag-step")[this.stepCurrent].querySelector(".btn-confirm") != null){
                document.querySelectorAll(".content-diag-step")[this.stepCurrent].querySelector(".btn-confirm").click();
            } 
        });  

        //Events 
        document.querySelectorAll(".content-diag-step").forEach((cstep, index) => { 
            cstep.setAttribute("data-index", index); 
            let mode = cstep.getAttribute("data-mode");   
            let dataStep =  cstep.getAttribute("data-step");  
            if(typeof this.diagQR[index] == "undefined"){
                this.diagQR[index] = [];
            }  
            cstep.querySelectorAll(".choix").forEach((a, i) => {  
                a.addEventListener("click", () => {   
                    if(mode == "solo"){  
                        if(dataStep == "peau" || dataStep == "symptome" || dataStep == "flux"){ 
                            this.diagSettings[dataStep] = a.getAttribute("data-select");
                        }
                        this.diagQR[index].push(i);
                        a.classList.add("active");
                        setTimeout(() => {
                            this.goToStep(this.stepCurrent + 1);
                        }, 200);
                    }else{    
                        if(a.classList.contains("reset")){
                            cstep.querySelectorAll(".choix.active").forEach(c => {
                                c.classList.remove("active");
                            });
                            a.classList.add("active");
                        }else{
                            if(cstep.querySelector(".choix.reset.active") != null){
                                cstep.querySelector(".choix.reset.active").classList.remove("active");
                            }
                            if(a.classList.contains("active")){
                                a.classList.remove("active");
                            }else{
                                a.classList.add("active");
                            }
                        }
                    } 
                }); 
            });

            if(mode == "multiple"){
                cstep.querySelector(".btn-confirm").addEventListener("click", () => { 
                    if(cstep.querySelectorAll(".choix.active").length > 0){   
                        cstep.querySelectorAll(".choix.active").forEach((c,i) => {
                            this.diagQR[index].push(i);
                        }); 
                        this.goToStep(this.stepCurrent+1);
                        this.killError();
                    }else{
                        this.showError("Vous devez séléctionner au moins un champs.", 2000);
                    }
                });
            }  
        }); 

        document.querySelector("#send-diag").addEventListener("click", async () => {
            const email = document.querySelector("#email").value;
            document.querySelector("#send-diag").classList.add("loading");
            if(this.validationEmail(email)){
                this.diagSettings.email = email;  
                await this.delay(500);
                this.goResult();
            }else{ 
                document.querySelector("#send-diag").classList.remove("loading");
            }
        });


         if(this.getParams("peau") != null && this.getParams("symptome") != null && this.getParams("flux") != null ){
            this.diag.querySelector(".diag").style.transition = `none`; 
            this.diagSettings = {
                "peau" : this.getParams("peau"),
                "symptome" : this.getParams("symptome"),
                "flux" : this.getParams("flux")
            }; 
            let goToResult = async () => {
                await this.delay(200);
                this.goResult(false);
            } 
            goToResult();
        }

        
        /*this.diagSettings = {
            "peau" : "grasse",
            "symptome" : "eruptions",
            "flux" : "leger"
        };
        this.diagQR = {
            0 : [],
            1 : [1],
            2 : [1],
            3 : [1],
            4 : [1],
            5 : [1],
            6 : [1],
            7 : [1],
            8 : [1],
            9 : [1,2],
            10 : [1,2]
        };*/
        //this.goToStep(this.countStep-2);
        
       //this.goToStep(1);
       //this.goToStep(this.countStep-2);
       //this.goToStep(9);
    }    

    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    getParams(parameterName) {
        var result = null,
            tmp = [];
        location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (decodeURIComponent(tmp[0]) === parameterName) result = decodeURIComponent(tmp[1]);
        });
        return result;
    }

    updateScrollbar(contentScrollbar, target) {
        const content = target.querySelector(".content-scrollable");
        const contentScrollHeight = content.scrollHeight;
        const contentHeight = content.clientHeight;
        const scrollRatio = contentHeight / contentScrollHeight;  
        const thumbHeight = (contentHeight * scrollRatio); 
        const thumbPosition = content.scrollTop * scrollRatio;

        contentScrollbar.querySelector(".cursor").style.height = `${thumbHeight}px`;
        contentScrollbar.querySelector(".cursor").style.top = `${thumbPosition}px`;
    }

    buildScrollbar(target){   
        let contentScrollbar = this.createElementWithClass("div", "content-scrollbar");
        let lineScrollbar = this.createElementWithClass("div", "line-scrollbar");
        let cursor = this.createElementWithClass("div", "cursor");
        contentScrollbar.appendChild(cursor);
        contentScrollbar.appendChild(lineScrollbar);
        target.appendChild(contentScrollbar); 
        this.updateScrollbar(contentScrollbar, target); 
        target.querySelector(".content-scrollable").addEventListener('scroll', () => {
            this.updateScrollbar(contentScrollbar, target); 
        });
    }

    createElementWithClass(type, className){
        var element = document.createElement(type);
        element.classList.add(className);
        return element;
    }

    killError(){
        var errors = document.querySelectorAll(".content-error");
        if(errors.length > 0){
            errors.forEach(e => {
                e.remove();
            })
        }
    }

    showFormError(messages, time){
        this.killError();
        var contentError = document.createElement("div");
        contentError.classList.add("content-error");
        var error = document.createElement("div");
        error.classList.add("error");
        let listError = this.createElementWithClass("ul", "list");
        messages.forEach(m => {
            let error = this.createElementWithClass("li", "error-text");
            error.innerHTML = m;
            listError.appendChild(error);
        })
        error.appendChild(listError);
        contentError.appendChild(error);
        document.querySelector("body").appendChild(contentError);
        setTimeout(() => {
            contentError.classList.add("show");
        },100); 
        setTimeout(() => {
            contentError.remove();
        }, time);
    }

    showError(message, time){
        this.killError();
        var contentError = document.createElement("div");
        contentError.classList.add("content-error");
        var error = document.createElement("div");
        error.classList.add("error");
        error.innerHTML = message;
        contentError.appendChild(error);
        document.querySelector("body").appendChild(contentError);
        setTimeout(() => {
            contentError.classList.add("show");
        },100); 
        setTimeout(() => {
            contentError.remove();
        }, time);
    }

    goResult(state){
        this.goToStep(this.countStep-2, state);
    }
 

    goToStep(index, state = true){   
        if(index == (this.countStep-2)){  
            const datasKlav = {datas : this.diagQR, settings: this.diagSettings}; 
            this.track(datasKlav, state);
        }
        if(document.querySelectorAll(".content-diag-step")[index+1].classList.contains("scrollable")){ 
            this.buildScrollbar(document.querySelectorAll(".content-diag-step")[index+1]);
        }   
        this.stepCurrent = index;   
        document.querySelectorAll(".content-diag-step")[index].classList.remove("off"); 
        document.querySelectorAll(".content-diag-step")[index].querySelectorAll(".choix").forEach(choix => {
            setTimeout(()=> {
                choix.classList.add("loaded");
            }, 300);
        });  
        
        let toScroll = this.diag.offsetHeight * (index+1);
        this.diag.querySelector(".diag").style.transform = `translateY(-${toScroll}px)`;  
    }
 
    addZero (number){
        if (number < 10) {
            number = "0" + number;
        }
        return number;
    } 

    getTime(date){
        return this.addZero(parseInt(date.getHours())) + ":" + this.addZero(parseInt(date.getMinutes())) + ":" + this.addZero(parseInt(date.getSeconds()));
    }

    removeItemOnce(arr, value) {
        var index = arr.indexOf(value);
        if (index > -1) {
          arr.splice(index, 1);
        }
        return arr;
    }   

    validationEmail(email){
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (email.match(validRegex)) {
            return true;
        }else{
            return false;
        }
    }

    buildResult(){    
        const diagResult = this.diagData[this.diagSettings.symptome]["peau_"+this.diagSettings.peau]; 
        document.querySelector(".resultat-desc .text-explications").textContent = diagResult.explications;
        document.querySelector(".resultat-desc .text-conseils").textContent = diagResult.recommandations; 
        this.buildProducts(diagResult.products.nov, document.querySelector(".resultat-products.nov .products"), "nov");
        this.buildProducts(this.diagDataSmoon[this.diagSettings.flux].products, document.querySelector(".resultat-products.smoon .products"), "smoon");
    }

    buildProducts(produits, target, brand){
        let prdCount = 0;
        let prdsHTML = "";
 
        produits.forEach(prd => {  

            if(brand == "nov"){
                const prdData = this.diagProducts["nov"][prd];  
                let prdHTML = `
                    <a class="product" href="${prdData.url}" target="_blank">
                        <div class="content">
                            <div class="content-image">
                                <div class="content-badge">
                                    <div class="badge" style="background: ${prdData.color};">
                                        ${prdData.cat}
                                    </div>
                                </div>
                                <div class="ab-gamme" style="color: ${prdData.color};">
                                    H<span>A</span>
                                </div>
                                <img src="${prdData.img}" /> 
                            </div>
                            <h2>
                                ${prdData.titre}
                            </h2>
                            <div class="content-stars">
                                5/5
                                <div class="stars"> 
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 12"> 
                                        <path d="M6.91,9.53l-2.85,1.93c-.77.52-1.35.13-1.05-.71l1.1-3.12s-.01-.1-.04-.12l-2.85-1.92c-.77-.52-.55-1.15.4-1.15h3.53s.1-.03.11-.06l1.08-3.12c.29-.84,1.01-.84,1.3,0l1.08,3.12s.07.07.11.07h3.53c.95,0,1.17.62.4,1.14l-2.86,1.92s-.05.09-.04.12l1.1,3.12c.3.84-.29,1.23-1.05.71l-2.85-1.93s-.1-.02-.13,0Z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 12"> 
                                        <path d="M6.91,9.53l-2.85,1.93c-.77.52-1.35.13-1.05-.71l1.1-3.12s-.01-.1-.04-.12l-2.85-1.92c-.77-.52-.55-1.15.4-1.15h3.53s.1-.03.11-.06l1.08-3.12c.29-.84,1.01-.84,1.3,0l1.08,3.12s.07.07.11.07h3.53c.95,0,1.17.62.4,1.14l-2.86,1.92s-.05.09-.04.12l1.1,3.12c.3.84-.29,1.23-1.05.71l-2.85-1.93s-.1-.02-.13,0Z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 12"> 
                                        <path d="M6.91,9.53l-2.85,1.93c-.77.52-1.35.13-1.05-.71l1.1-3.12s-.01-.1-.04-.12l-2.85-1.92c-.77-.52-.55-1.15.4-1.15h3.53s.1-.03.11-.06l1.08-3.12c.29-.84,1.01-.84,1.3,0l1.08,3.12s.07.07.11.07h3.53c.95,0,1.17.62.4,1.14l-2.86,1.92s-.05.09-.04.12l1.1,3.12c.3.84-.29,1.23-1.05.71l-2.85-1.93s-.1-.02-.13,0Z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 12"> 
                                        <path d="M6.91,9.53l-2.85,1.93c-.77.52-1.35.13-1.05-.71l1.1-3.12s-.01-.1-.04-.12l-2.85-1.92c-.77-.52-.55-1.15.4-1.15h3.53s.1-.03.11-.06l1.08-3.12c.29-.84,1.01-.84,1.3,0l1.08,3.12s.07.07.11.07h3.53c.95,0,1.17.62.4,1.14l-2.86,1.92s-.05.09-.04.12l1.1,3.12c.3.84-.29,1.23-1.05.71l-2.85-1.93s-.1-.02-.13,0Z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 12"> 
                                        <path d="M6.91,9.53l-2.85,1.93c-.77.52-1.35.13-1.05-.71l1.1-3.12s-.01-.1-.04-.12l-2.85-1.92c-.77-.52-.55-1.15.4-1.15h3.53s.1-.03.11-.06l1.08-3.12c.29-.84,1.01-.84,1.3,0l1.08,3.12s.07.07.11.07h3.53c.95,0,1.17.62.4,1.14l-2.86,1.92s-.05.09-.04.12l1.1,3.12c.3.84-.29,1.23-1.05.71l-2.85-1.93s-.1-.02-.13,0Z"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="benefices">
                                ${prdData.benefices}
                            </div>
                            <div class="price">
                                ${prdData.price}€
                            </div>
                        </div>
                    </a> 
                `;
                prdsHTML += prdHTML;
            }else{
                const prdData = this.diagProducts["smoon"][prd];  
                let gouttes = "";
                for(let i = 0; i < prdData.gouttes; i++){
                    gouttes += `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 15 22">
                        <path class="st0" d="M15,14.83c0,3.97-3.35,7.17-7.5,7.17S0,18.8,0,14.83,7.41,0,7.41,0c0,0,7.59,10.86,7.59,14.83Z"/>
                    </svg>`;
                }
                let prdHTML = `
                    <a class="product" href="${prdData.url}" target="_blank">
                        <div class="content">
                            <div class="content-image">
                                <img src="${prdData.img}" />
                                <div class="content-stars">
                                    ${prdData.rating}/5
                                    <div class="stars"> 
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 12"> 
                                            <path d="M6.91,9.53l-2.85,1.93c-.77.52-1.35.13-1.05-.71l1.1-3.12s-.01-.1-.04-.12l-2.85-1.92c-.77-.52-.55-1.15.4-1.15h3.53s.1-.03.11-.06l1.08-3.12c.29-.84,1.01-.84,1.3,0l1.08,3.12s.07.07.11.07h3.53c.95,0,1.17.62.4,1.14l-2.86,1.92s-.05.09-.04.12l1.1,3.12c.3.84-.29,1.23-1.05.71l-2.85-1.93s-.1-.02-.13,0Z"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 12"> 
                                            <path d="M6.91,9.53l-2.85,1.93c-.77.52-1.35.13-1.05-.71l1.1-3.12s-.01-.1-.04-.12l-2.85-1.92c-.77-.52-.55-1.15.4-1.15h3.53s.1-.03.11-.06l1.08-3.12c.29-.84,1.01-.84,1.3,0l1.08,3.12s.07.07.11.07h3.53c.95,0,1.17.62.4,1.14l-2.86,1.92s-.05.09-.04.12l1.1,3.12c.3.84-.29,1.23-1.05.71l-2.85-1.93s-.1-.02-.13,0Z"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 12"> 
                                            <path d="M6.91,9.53l-2.85,1.93c-.77.52-1.35.13-1.05-.71l1.1-3.12s-.01-.1-.04-.12l-2.85-1.92c-.77-.52-.55-1.15.4-1.15h3.53s.1-.03.11-.06l1.08-3.12c.29-.84,1.01-.84,1.3,0l1.08,3.12s.07.07.11.07h3.53c.95,0,1.17.62.4,1.14l-2.86,1.92s-.05.09-.04.12l1.1,3.12c.3.84-.29,1.23-1.05.71l-2.85-1.93s-.1-.02-.13,0Z"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 12"> 
                                            <path d="M6.91,9.53l-2.85,1.93c-.77.52-1.35.13-1.05-.71l1.1-3.12s-.01-.1-.04-.12l-2.85-1.92c-.77-.52-.55-1.15.4-1.15h3.53s.1-.03.11-.06l1.08-3.12c.29-.84,1.01-.84,1.3,0l1.08,3.12s.07.07.11.07h3.53c.95,0,1.17.62.4,1.14l-2.86,1.92s-.05.09-.04.12l1.1,3.12c.3.84-.29,1.23-1.05.71l-2.85-1.93s-.1-.02-.13,0Z"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 12"> 
                                            <path d="M6.91,9.53l-2.85,1.93c-.77.52-1.35.13-1.05-.71l1.1-3.12s-.01-.1-.04-.12l-2.85-1.92c-.77-.52-.55-1.15.4-1.15h3.53s.1-.03.11-.06l1.08-3.12c.29-.84,1.01-.84,1.3,0l1.08,3.12s.07.07.11.07h3.53c.95,0,1.17.62.4,1.14l-2.86,1.92s-.05.09-.04.12l1.1,3.12c.3.84-.29,1.23-1.05.71l-2.85-1.93s-.1-.02-.13,0Z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <h2>
                                ${prdData.titre}
                            </h2>
                            <div class="flux"> 
                                <span>flux ${prdData.flux}</span>
                                <div class="pictos"> 
                                    ${gouttes}
                                </div>
                            </div>
                            <div class="price">
                                ${prdData.price}
                            </div>
                        </div>
                    </a> 
                `;
                prdsHTML += prdHTML;
            } 

        });
        target.innerHTML = prdsHTML;  
    }

    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    } 

    partagerPDF(url) { 

      if (navigator.share) {
        navigator.share({
          title: 'Le résultat de mon diagnostic ',
          text: 'Ce qui se passe vraiment dans mon corps pendant mon cycle.',
          url: url,
        })
        .then(() => console.log('Partagé avec succès'))
        .catch((error) => console.error('Erreur de partage', error));
      } else {
        // Fallback si l'API Web Share n'est pas disponible
        prompt("Copiez ce lien pour partager :", url);
      }
    }

    formatPrice(price, currency){
        switch(currency){
            case "EUR" : var devise = "€"; break;
            default : var devise = "€";  
        }
        return (price / 100).toFixed(2) + devise;
    }

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    setCookie(name,value,days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    } 

    async track(obj, state){  
        var objToString = "";    
        Object.entries(obj.datas).forEach((field, index) => {  
            if(field[1].length > 0){
                const ar = field[1].join("/");
                objToString += `"question_${field[0]}" : "${ar}",`;   
            }
        });     

        Object.entries(obj.settings).forEach((field, index) => {   
            objToString += `"${field[0]}" : "${field[1]}"`;  
            if(index < Object.entries(obj.settings).length - 1){
                objToString += ","
            } 
        });  

        const options = {
            method: 'POST',
            headers: {
                Accept: 'text/html', 
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                data: `{
                    "token": "${this.options.apiK}", 
                    "event": "diag-smoon", 
                    "customer_properties" : {
                        "$email" : "${obj.settings.email}"
                    },
                    "properties": {
                        ${objToString}
                    }
                }`
            })
        };

        

        if(state){
            if (typeof fbq === 'function') {
                fbq('track', 'CompleteRegistration');
            }

            const trackK = await fetch('https://a.klaviyo.com/api/track', options); 

            if(trackK.ok){
                console.log("tracking klaviyo"); 
            }
        }
 

        this.buildResult(); 
         
    } 

    async checkKlaviyo(dataEmail){  
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: 'TcjGBX'})
        };
        const call = await fetch("https://wlaud0uwn1.execute-api.eu-west-3.amazonaws.com/Prod/klaviyo/checklist", options);  
        const rep = await call.json();   
        if(rep.rep.data.length == 0){ 
            await this.subKlaviyo(dataEmail, source); 
        }else{
          let sub = false;
          rep.rep.data.forEach(d => {
            if(d.id == "TcjGBX"){
              sub = true;
            }
          });
          if(!sub){
            await this.subKlaviyo(dataEmail, source);
          }
        }
    }

    async subKlaviyo(dataEmail){   
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: 'TcjGBX', source: "diag"})
        };
        const call = await fetch("https://wlaud0uwn1.execute-api.eu-west-3.amazonaws.com/Prod/klaviyo/subscribe", options);  
        const rep = await call.json();  
        if(typeof rep.statut != "undefined" && rep.statut == "save"){
            console.log("success"); 
        }  
    }

    get diagSave (){  
        return this.diagData;
    }

    get headerHeight(){
        return document.querySelector("#header").offsetHeight;
    }
};

